import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOnOutlined';
import MailIcon from '@mui/icons-material/MailOutline';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import { SavedQueriesList } from 'react-admin';
import {
    endOfYesterday,
    startOfWeek,
    subWeeks,
    startOfMonth,
    subMonths,
} from 'date-fns';

import SubscriberIcon from '@mui/icons-material/Domain';
import ProductIcon from '@mui/icons-material/LibraryBooks';
import StatusIcon from '@mui/icons-material/CheckCircle';

import CustomFilterList from '../../controls/CustomFilterList';
import CustomFilterSearch from '../../controls/CustomFilterSearch';
import StaticFilterList from '../../controls/StaticFilterList';
import MinLengthFilterLiveSearch from '../../controls/MinLengthFilterLiveSearch';

//import segments from '../segments/data';

const TeacherListAside = () => (
    <Card
        sx={{
            display: {
                xs: 'none',
                md: 'block',
            },
            order: -1,
            flex: '0 0 15em',
            mr: 2,
            mt: 4.5,
            alignSelf: 'flex-start',
        }}
    >
        <CardContent sx={{ pt: 1 }}>
            <MinLengthFilterLiveSearch
                source="q"
                variant="outlined"
                minLength={3}
            />
            <SavedQueriesList />
            <CustomFilterList
                url="extralist/teacher/statuses"
                label="resources.user.filters.status"
                source="status"
                icon={<StatusIcon />}
            />
            <StaticFilterList
                source="invitation_delivery"
                label="resources.user.filters.invitation_delivery"
                icon={<MailIcon />}
                items={[
                    {
                        label: 'resources.user.invitation.delivery.delivered',
                        value: { invitation_delivery: 'delivered' },
                    },
                    {
                        label: 'resources.user.invitation.delivery.failed',
                        value: { invitation_delivery: 'failed' },
                    },
                    {
                        label: 'resources.user.invitation.delivery.pending',
                        value: { invitation_delivery: 'pending' },
                    },
                    {
                        label: 'resources.user.invitation.delivery.unknown',
                        value: { invitation_delivery: 'unknown' },
                    },
                    {
                        label: 'resources.user.invitation.delivery.resend_exhausted',
                        value: { invitation_delivery: 'resend_exhausted' },
                    },
                ]}
            />
            <CustomFilterSearch
                url="extralist/schools"
                label="resources.user.filters.schools"
                source="parent_group"
                variant="filled"
                storeKey="teacher.filters.schools"
                //storeKeyToClear="store.subscription.subscriber_users"
                icon={<SubscriberIcon />}
            />
        </CardContent>
    </Card>
);

export default TeacherListAside;
